import dayjs, { Dayjs } from "dayjs"

import { BirthPlace, Gender } from "../types/new/types/entity"
import { Amo, Cmu, DataCarteVitale, PatientSesam, RightsPeriod, T_AsnBeneficiaire } from "../types/new/types/sesam"
import { NirReaderResponse } from "../types/new/types/store"
import { century, DATE_FORMAT } from "./utils"
import { InputNames } from "types/new/types/props"

export const getPatientFromDataCarteVitale = (
  data: DataCarteVitale
): Partial<PatientSesam> => {
  let beneficiaire: T_AsnBeneficiaire | T_AsnBeneficiaire[] =
    data.T_AsnDonneesVitale?.listeBenef?.T_AsnBeneficiaire || {}
  if (Array.isArray(beneficiaire)) beneficiaire = beneficiaire[0]

  return getPatientFromBeneficiaire(beneficiaire)
}

export const getInseeCodeFromNir = (nir: string): string | 99999 => {
  return (nir && nir.substring(5, 10)) || 99999;
}

export const getBirthCountryFromNir = (nir: string): string => {
  if (nir) {
    return nir.substring(5, 7) === '99' ? `${BirthPlace.FOREIGN}` : `${BirthPlace.FRANCE}`;
  }
  return `${BirthPlace.UNKNOWN}`;
}

export const getPatientFromBeneficiaire = (
  beneficiaire: T_AsnBeneficiaire,
  isRelative?: boolean | false
): Partial<PatientSesam> => {
  const nir: string = beneficiaire.ident?.nir?.replace(" ", "") || ""
  const birthdateInCard =
    beneficiaire.ident?.naissance?.date ??
    beneficiaire.ident?.naissance?.dateEnCarte
  const patient: Partial<PatientSesam> = {
    nir: nir,
    birthdate: getBirthdateFromNir(birthdateInCard) as any,
    firstname: beneficiaire.ident?.prenomUsuel || "",
    first_birth_firstname: beneficiaire.ident?.prenomUsuel,
    lastname: beneficiaire.ident?.nomUsuel || "",
    birth_lastname: beneficiaire.ident?.nomPatronymique || beneficiaire.ident?.nomUsuel || "",
    sex: !isRelative ? nir && nir[0] === "1" ? Gender.MALE : Gender.FEMALE : null,
    birth_country: getBirthCountryFromNir(nir),
    amo: beneficiaire.amo
      ? { periods: getAMORightsPeriod(beneficiaire.amo) }
      : undefined,
    cmu: beneficiaire.cmu
      ? { periods: getCMURightsPeriod(beneficiaire.cmu) }
      : undefined,
    [InputNames.INSEE_CODE]: isRelative ? null : getInseeCodeFromNir(nir)
  }
  return patient
}

export const getMainBeneficiaire = (
  data: DataCarteVitale
): T_AsnBeneficiaire => {
  let beneficiaire: T_AsnBeneficiaire | T_AsnBeneficiaire[] =
    data.T_AsnDonneesVitale?.listeBenef?.T_AsnBeneficiaire || {}
  if (Array.isArray(beneficiaire)) beneficiaire = beneficiaire[0]
  return beneficiaire
}

export const getRelativesFromDataCarteVtiale = (
  data: DataCarteVitale
): Partial<PatientSesam>[] => {
  const beneficiaires: T_AsnBeneficiaire | T_AsnBeneficiaire[] =
    data.T_AsnDonneesVitale?.listeBenef?.T_AsnBeneficiaire || {}

  if (Array.isArray(beneficiaires)) {
    const relatives: Partial<PatientSesam>[] = []
    beneficiaires.forEach((beneficiaire, key) => {
      if (key !== 0) {
        relatives.push(getPatientFromBeneficiaire(beneficiaire, true))
      }
    })
    return relatives
  } else return []
}

export const isPatientExempted = (patient: Partial<PatientSesam>): boolean => {
  const cmu = patient.cmu
  if (!cmu) return false
  const now = dayjs()
  if (cmu.periods?.end && cmu.periods.end >= now) return true
  return false
}

export const getPatientsFromDataCarteVitale = (
  data: DataCarteVitale
): NirReaderResponse => {
  return {
    patient: getPatientFromDataCarteVitale(data) as any,
    relatives: getRelativesFromDataCarteVtiale(data) as any,
  }
}

const getCMURightsPeriod = (cmu: Cmu): RightsPeriod | undefined => {
  if (cmu?.periode?.fin) return { end: nirDateToDate(cmu?.periode?.fin) }
  return undefined
}
const getAMORightsPeriod = (amo: Amo): RightsPeriod => {
  return {
    start: amo?.listePeriodesDroits?.T_AsnPeriode?.debut
      ? nirDateToDate(amo.listePeriodesDroits.T_AsnPeriode.debut)
      : undefined,
    end: amo?.listePeriodesDroits?.T_AsnPeriode?.fin
      ? nirDateToDate(amo.listePeriodesDroits.T_AsnPeriode.fin)
      : undefined,
  }
}

const nirDateToDate = (nirDate: string): Dayjs | undefined => {
  // nirDate = "" || nirDate =
  if (nirDate.length === 6) {
    // AAMMJJ
    return dayjs(nirDate, "YYMMDD")
  } else if (nirDate.length === 8) {
    // JJMMAAAA
    return dayjs(nirDate, "DDMMYYYY")
  } else return undefined
}

const getBirthdateFromNir = (date: string | undefined) => {
  if (!date) return undefined
  let day,
    month,
    year = ""
  if (date.length === 6) {
    day = date.substring(4, 6)
    month = date.substring(2, 4)
    // Get Century
    const yy = parseInt(date.substring(0, 2))
    console.log('century', century(yy).toString());
    year = century(yy).toString()
  }
  if (date.length === 8) {
    day = date.substring(0, 2)
    month = date.substring(2, 4)
    year = date.substring(4, 8)
  }
  const birthdate: Dayjs = dayjs(`${day}/${month}/${year}`, DATE_FORMAT)
  return birthdate
}
